import { useState, useCallback } from "react";
import { apiService } from "../services/apiClient";
import { apiUrl } from "../services/apiUrl";

export const useFaqAdmin = () => {
  const [faqs, setFaqs] = useState([]);
  const [faqsLoading, setFaqsLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [deleting, setDeleting] = useState(false);

  // Fetch all FAQs
  const fetchFaqs = useCallback(async () => {
    setFaqsLoading(true);
    try {
      const response = await apiService.get(apiUrl.aipdGetAllFaqs());
      setFaqs(response.data || []);
      return response.data || [];
    } catch (err) {
      console.error("Error fetching FAQs:", err.response?.data?.message || err.message);
      setFaqs([]);
    } finally {
      setFaqsLoading(false);
    }
  }, []);

  // Create FAQ
  const createFaq = useCallback(async (data) => {
    setSubmitting(true);
    try {
      const response = await apiService.post(apiUrl.aipdPostFaq(), data);
      return response.data;
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      console.error("Error creating FAQ:", message);
      throw err;
    } finally {
      setSubmitting(false);
    }
  }, []);

  // Update FAQ
  const updateFaq = useCallback(async (data) => {
    setSubmitting(true);
    try {
      const response = await apiService.post(apiUrl.aipdUpdateFaq(), data);
      return response.data;
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      console.error("Error updating FAQ:", message);
      throw err;
    } finally {
      setSubmitting(false);
    }
  }, []);

  // Delete FAQ
  const deleteFaq = useCallback(async (id) => {
    setDeleting(true);
    try {
      await apiService.delete(apiUrl.aipdDeleteFaq(), { data: { id } });
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      console.error("Error deleting FAQ:", message);
      throw err;
    } finally {
      setDeleting(false);
    }
  }, []);

  return {
    faqs,
    faqsLoading,
    submitting,
    deleting,
    fetchFaqs,
    createFaq,
    updateFaq,
    deleteFaq,
  };
};

export default useFaqAdmin;
